/**
 * @file Route: singleblog
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import { $all, forEach, on } from "@olmokit/dom";
import { Header } from "components/Header/Info";
import "components/Cover";
// import { clickCta } from "components/Dl";
import { Blogroll } from "components/Blogroll";
import "./index.scss";

console.log("Route singleblog/index.js mounted.");

Header();
Blogroll();

const ctas = $all(".dlClickCta");
if (ctas) {
  forEach(ctas, c => {
    on(c, "click", () => {
    //   clickCta(c.getAttribute("data-link"), c.getAttribute("data-label"));
    });
  });
}
